import { render, staticRenderFns } from "./DynamicCRF.vue?vue&type=template&id=21b53a04"
import script from "./DynamicCRF.vue?vue&type=script&lang=js"
export * from "./DynamicCRF.vue?vue&type=script&lang=js"
import style0 from "./DynamicCRF.vue?vue&type=style&index=0&id=21b53a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports